import React from 'react'

import './navigation-divider.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    collapse?: boolean
  }
>

const NavigationDivider = ({className, children, collapse = false, ...props}: Props) => (
  <div {...props} className={cn('NavigationDivider', {collapse}, className)}>
    {children}
  </div>
)

export default NavigationDivider
